import { Beneficiaries } from 'BreetComponents';
import type { IBeneficiary } from 'BreetHelpers';
import { useCallback, useState } from 'react';

const ManageBeneficiaries = ({ onAddNewBeneficiary }: { onAddNewBeneficiary?: () => void }) => {
	const [selectedBeneficiary, setSelectedBeneficiary] = useState<IBeneficiary | undefined>(undefined);

	const selectBeneficiary = useCallback((beneficiary: IBeneficiary | undefined) => {
		setSelectedBeneficiary(beneficiary);
	}, []);

	return (
		<div className='managebeneficiary'>
			<Beneficiaries
				mode='delete'
				selectBeneficiary={selectBeneficiary}
				selectedBeneficiaryId={selectedBeneficiary?._id}
				onAddNewBeneficiary={onAddNewBeneficiary}
				filterOutType='virtual_account'
			/>
		</div>
	);
};

export default ManageBeneficiaries;
